module.exports = __webpack_public_path__ + "static/media/11x17no1.ba72d746.jpg";